import React, { Suspense, lazy } from 'react';
import { Hero } from './components/Hero';
// Lazy load below-the-fold sections
const SocialProof = lazy(() => import('./components/SocialProof').then(m => ({
  default: m.SocialProof
})));
const Testimonials = lazy(() => import('./components/Testimonials').then(m => ({
  default: m.Testimonials
})));
const PainPoints = lazy(() => import('./components/PainPoints').then(m => ({
  default: m.PainPoints
})));
const ProductOverview = lazy(() => import('./components/ProductOverview').then(m => ({
  default: m.ProductOverview
})));
const TomosDetail = lazy(() => import('./components/TomosDetail').then(m => ({
  default: m.TomosDetail
})));
const Bonuses = lazy(() => import('./components/Bonuses').then(m => ({
  default: m.Bonuses
})));
const Pricing = lazy(() => import('./components/Pricing').then(m => ({
  default: m.Pricing
})));
const AcceleratorComparison = lazy(() => import('./components/AcceleratorComparison').then(m => ({
  default: m.AcceleratorComparison
})));
const Guarantee = lazy(() => import('./components/Guarantee').then(m => ({
  default: m.Guarantee
})));
const FAQ = lazy(() => import('./components/FAQ').then(m => ({
  default: m.FAQ
})));
const CostComparison = lazy(() => import('./components/CostComparison').then(m => ({
  default: m.CostComparison
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
export function App() {
  return <div className="min-h-screen bg-brand-bg text-brand-text font-body selection:bg-brand-cta selection:text-white" data-id="element-0">
      {/* Above the fold — only Hero loaded eagerly */}
      <Hero data-id="element-1" />

      {/* Everything else lazy loaded */}
      <Suspense fallback={null} data-id="element-2">
        <SocialProof data-id="element-3" />
        <Testimonials limit={3} data-id="element-4" />
        <PainPoints data-id="element-5" />
        <Pricing id="pricing-early" data-id="element-6" />
        <ProductOverview data-id="element-7" />
        <TomosDetail data-id="element-8" />
        <Bonuses data-id="element-9" />

        {/* Vista previa: Protocolos por tipo de piel */}
        <div className="max-w-4xl mx-auto px-4 py-12" data-id="element-10">
          <figure data-id="element-11">
            <img src="https://cdn.magicpatterns.com/uploads/3jXwSsiJrTMg639gaZzY57/Diseno_sin_titulo_(1).webp" alt="Vista previa del contenido: Protocolos personalizados por tipo de piel" width={1000} height={750} loading="lazy" decoding="async" className="w-full rounded-lg shadow-md" style={{
            maxWidth: '100%',
            borderRadius: '8px'
          }} data-id="element-12" />
            <figcaption className="font-body text-sm text-brand-subtitle text-center mt-4 italic px-4" data-id="element-13">
              Rutinas personalizadas: Protocolos específicos para Piel Madura,
              Acnéica, Reactiva y Normal. Por fin una solución que entiende tu
              caso particular.
            </figcaption>
          </figure>
        </div>

        <Pricing id="pricing" data-id="element-14" />
        <AcceleratorComparison data-id="element-15" />
        <Testimonials limit={6} className="pt-8" data-id="element-16" />
        <Guarantee data-id="element-17" />
        <FAQ data-id="element-18" />
        <CostComparison data-id="element-19" />

        <div className="flex flex-wrap justify-center gap-6 text-sm text-brand-subtitle font-medium pb-16 px-4" data-id="element-20">
          <span className="flex items-center gap-2" data-id="element-21">🔒 Pago 100% seguro</span>
          <span className="flex items-center gap-2" data-id="element-22">
            ⚡ Acceso en 5 minutos
          </span>
          <span className="flex items-center gap-2" data-id="element-23">
            🛡️ Garantía 7 días sin preguntas
          </span>
          <span className="flex items-center gap-2" data-id="element-24">
            💳 Tarjeta de crédito | Débito | PayPal
          </span>
        </div>

        <Footer data-id="element-25" />
      </Suspense>
    </div>;
}